import React from 'react';

const DraggableSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <circle cx="7" cy="6" r="1.5" fill={color} />
      <circle cx="7" cy="12" r="1.5" fill={color} />
      <circle cx="7" cy="18" r="1.5" fill={color} />
      <circle cx="13" cy="6" r="1.5" fill={color} />
      <circle cx="13" cy="12" r="1.5" fill={color} />
      <circle cx="13" cy="18" r="1.5" fill={color} />
    </svg>
  );
};

export default DraggableSVG;
